// @ts-nocheck
import React, { useState } from "react";
import genRequest from "includes/request";
import { useQuery, useQueryClient } from "react-query";
// Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faSolidHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import useAccount from "classes/Accounts/hooks/useAccount";
import { t } from "i18next";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";

export default function LikePostBtn(props) {
	const { account, getSettings } = useAccount();
	const { postId, postTypeId, setIsOpen } = props;
	// const [referenceElement, setReferenceElement] = useState(null);
	const QCL = useQueryClient();
	const isMobile = useMediaQuery({ query: "(max-width: 700px)" });
	let isUpdating = false;
	// In v1 a "like" was always a thumbs reaction (clicking like also
	// inserted reaction id=30, and clicking thumbs from the popper went
	// through the same like flow). v2 now mirrors that sync inside
	// reactions.service so /posts/:id/likes stays accurate when users
	// react via the popper — keep reading from the legacy endpoint.
	const reactionsEnabled = getSettings("Reactions");

	const fetchLikes = () => {
		let req = genRequest("posts/" + postId + "/likes")
			.then((resp) => {
				if (resp?.length) {
					let liked = resp.find((a) => a.employeeId === account.employeeId);
					return ({
						likes: resp,
						isLiked: liked
					});
				}
				return ({
					likes: [],
					isLiked: false
				});
			}, () => {
				return ({
					likes: [],
					isLiked: false
				});
			});
		return (req);
	};

	function gestLikePost() {
		if (isUpdating)
			return (isUpdating);
		let req = likePost().then(() => {
			isUpdating = false;
			QCL.refetchQueries(["LtEmployesLikedposts", "PostId", postId]);
		}, () => {
			isUpdating = false;
			QCL.refetchQueries(["LtEmployesLikedposts", "PostId", postId]);
		});
		isUpdating = req;
		return (req);
	}

	const likePost = () => {
		if (!postId)
			return (false);
		if (data?.isLiked)
			return (unLikePost());
		const req = genRequest(
			"posts/" + postId + "/like",
			null,
			"post"
		).catch((e) => {
			if (e?.response?.status === 409) return unLikePost();
			throw e;
		});
		return (req);
	};

	const unLikePost = () => {
		if (!postId)
			return (false);
		const req = genRequest(
			"posts/" + postId + "/like",
			null,
			"delete"
		);
		return (req);
	};

	const { isLoading, data } = useQuery(
		["LtEmployesLikedposts", "PostId", postId],
		fetchLikes,
		{ retry: 0, enabled: (postId ? true : false) },
	);

	const count = data?.likes?.length ? data.likes.length : 0;

	return (
		<div
			className={"post-likes-cont d-flex align-items-center cursor-pointer" + (props.className ? " " + props.className : "")}
			title={count + " " + t("Posts.LIKES", { count })}
			onMouseEnter={() => setIsOpen(true)}
		>
			<div
				className="d-flex align-items-center"
				onClick={reactionsEnabled ? () => setIsOpen(true) : gestLikePost}
			>
				<span className={clsx("icons icon-bulle-like", isMobile ? "f-16" : "f-10")}></span>
				{
					isLoading ?
						<div className="ms-1 d-flex align-items-center loading">
							<div style={{ width: "10px", height: "5px" }}></div>
						</div>
						:
						<div className="post-likes-count ms-1">{count}</div>
				}
			</div>

		</div>
	);
}
